module.exports = __webpack_public_path__ + "media/images/v2/vimeo_logo-64f428c84a78fb0a80a79f7854b9a404.png";